(function () {
    var sessionParam = "firstArticleStart";
    var lastUrlParam = "lastUrl";
    var TimeAllowedBtwArticles = 1000 * 60 * 30;

    function resetLastArticle(url) {
        TCT.Cookies.setCookie(lastUrlParam, url, 7);
    }

    function resetSessionTime(t) {
        TCT.Cookies.setCookie(sessionParam, t, 7);
    }

    function isUrlRelevant(url) {
        var n = url.indexOf("/articles/");
        return n != -1;
    }

    var url = window.location.href;
    if (isUrlRelevant(url)) {   // This script is only about articles
        var firstArticleTime = TCT.Cookies.getCookie(sessionParam);
        var lastUrl = TCT.Cookies.getCookie(lastUrlParam);
        var currentTime = new Date().getTime();

        if (firstArticleTime == "") { //new session

        } else {
            if (url == lastUrl) { //Probably a refresh on the same article - does not count

            } else {
                var diff = currentTime - firstArticleTime;
                if (diff > TimeAllowedBtwArticles) { //Too much time, consider this as a new session
                } else {
                    trackConversion('2nd-article', url);
                }
            }
        }

        resetSessionTime(currentTime);
        resetLastArticle(url);
    }
})();